<template>
    <v-row class="list-items loading-wrapper" align="center" justify="center">
        <v-col cols="auto">
            <transition v-show="showLoading" enter-active-class="animate__animated animate__fadeInDown">
                <div class="text-center lightness">
                    <v-img max-height="30vh" contain :src="file_logo" v-if="current_financial_file.company_logo_file"></v-img>
                    <v-img v-else max-height="30vh" contain :src="require('../../assets/Emerald.png')" transtion="scale-transition">
                    </v-img>
                </div>
            </transition>
             
            <transition enter-active-class="animate__animated animate__fadeInDown">
                <v-card-subtitle v-show="showLoading" class="text-center primary--text">
                    {{$t('loading-text')}}
                </v-card-subtitle>
            </transition>

            <transition v-show="showProgressBar" enter-active-class="animate__animated animate__fadeIn">
                <bee-progress-linear
                    class="mx-auto"
                    v-show="showProgressBar"
                    style="width:15vw"
                    indeterminate
                    rounded
                    height="6"
                    :reverse="$i18n === 'ar'"
                    color="primary">
                </bee-progress-linear>
            </transition>

            <transition v-show="showLoading" enter-active-class="animate__animated animate__fadeInDown">
                <v-card-subtitle v-show="showLoading" class="text-center primary--text font-weight-bold">Emerald <span>{{settings.SYSTEM_VERSION}}</span></v-card-subtitle>
            </transition>
        </v-col>
    </v-row>
</template>
<script>
import  store  from "../../store/index.js"
import { mapState } from "vuex";
import EventBus from '../../event-bus'
import * as settings from "../../settings/index.js"
import ls from '../../settings/localStorageExtension'
import { bondType, userType } from '@/helpers/enums.js'
import { multipleWarehouses, useInvoiceCategories } from '@/configs/global.js'
export default {
    data:()=>({
        showLoading: false,
        showProgressBar: false,
        settings: settings,
        userType,
        multipleWarehouses,
        useInvoiceCategories,
        currentFinancialFileId: ls.getLocalFinancialFileId(),
    }),
    mounted: function () {
        Promise.all([
            store.dispatch('permissions/fetchPermissionType', {
                user_id: ls.getLocalUser().id, 
                financial_file_id: ls.getLocalFinancialFileId()
            }),
            this.currentFinancialFileId ? store.dispatch("financialFiles/fetchFinancialFile", ls.getLocalFinancialFileId()) : null
        ])
        // .then((data)=> {
        .then(()=> {
            if( this.currentFinancialFileId) {
                this.$nextTick(function () {
                    setTimeout(()=>{
                        this.showLoading = true
                        let promises = []
                        if(ls.getLocalUser()) {
                            promises.push(store.dispatch('users/fetchOneUser',ls.getLocalUser()?.id))
                        }
                        // configs
                        let configs = store.state.configs.configs
                        if(Object.keys(configs).length == 0)
                            promises.push(store.dispatch("configs/fetchAll"))

                        // custom_statements
                        let custom_statements = store.state.customStatements.custom_statements
                        if(Object.keys(custom_statements).length == 0)
                            promises.push(store.dispatch("customStatements/fetchAll"))
                        // Global Settings
                        let globalSettings = store.state.settings.globalSettings;
                        !globalSettings.length
                            ? promises.push(store.dispatch('settings/fetchGlobalSettings').then(() => {
                                // settings
                                promises.push(store.dispatch('settings/fetchFinancialFileSettings', this.currentFinancialFileId))
                                }))
                            : null
                        // accounting_bonds
                        let accounting_bonds = store.state.bonds.simplified_accounting_bonds
                        if(accounting_bonds.length == 0)
                            promises.push(store.dispatch("bonds/fetchAll", { bondType: bondType.accounting }))
                        
                        // cash_bonds
                        let cash_bonds = store.state.bonds.simplified_cash_bonds
                        if(cash_bonds.length == 0)
                            promises.push(store.dispatch("bonds/fetchAll", { bondType: bondType.cash }))
                        let invoiceCategories = store.state.invoiceCategories.invoiceCategories;
                        if (!invoiceCategories.length && useInvoiceCategories) {
                            promises.push(this.$store.dispatch('invoiceCategories/fetchAll'));
                            promises.push(this.$store.dispatch('invoiceCategories/fetchDefaultCategories'));
                        }
                        // let buy_invoices = JSON.parse(JSON.stringify(store.state.invoices.simplified_buy_invoices))
                        // if(buy_invoices.length == 0)
                        //     promises.push(store.dispatch("invoices/fetchAll", "Buy"))

                        // let sale_invoices = JSON.parse(JSON.stringify(store.state.invoices.simplified_sale_invoices))
                        // if(sale_invoices.length == 0)
                        //     promises.push(store.dispatch("invoices/fetchAll", "Sale"))

                        if(promises.length)
                            Promise.all(promises)
                            .then(()=>{ 
                                EventBus.$emit('data-loaded')
                            })
                    }, 1000)
                    // BUG remove comments for warehouses
                    /* if(data[0]) {
                        if(data[0].permission_type === userType.warehouseKeeper && multipleWarehouses) {
                            this.$store.dispatch('warehouses/fetchWarehousesByIds', { warehouseIds: data[0].warehouse_ids })
                        }
                    } */
                });
                setTimeout(()=>{
                    this.showProgressBar = true
                },1300)
            }
        })
        
    },
    methods: {
        addRandomNumberToList() {
            this.index = this.index + 1;
            let char= this.word[this.index];
            this.randomNumbers.push(char);
        },
        deleteRandomNumber(index) {
            this.randomNumbers.splice(index, 1);
        },
    },
    computed:{
        ...mapState("financialFiles" , ["current_financial_file"]),
        file_logo(){  
            return axios.defaults.baseURL.replace('/api/', '') + '/Content/FinancialFiles/Logos/' + this.current_financial_file.company_logo_file
        },
    },

    i18n:{
        messages:{
            ar: { 'loading-text': 'جاري تحميل البيانات لبدء النظام...' },
            en: { 'loading-text': 'Loading data to start the system...' },
            es: { 'loading-text': 'Cargando datos para iniciar el sistema...' },
        },
    }
}
</script>
<style>
.loading-wrapper {
    position: fixed;
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
}
.list-items {
    display: flex;
    align-items: center;
    justify-content: center;
}
.lightness {
    animation-name: example;
    animation-duration: 2s;
    animation-iteration-count: infinite;
}

@keyframes example {
    0%   {
        opacity: 1;
    }
    50%  {
        opacity: 0.5;
    }
    100% {
        opacity: 1;
    }
}
</style>